import React from 'react';
import { CheckCircle, FileText } from 'lucide-react';
import CustomizedDialogs from '../../model/CustomizedDialogs.tsx';

interface InterviewCompletionScreenProps {
  allPhasesComplete: boolean;
  summary: string;
  summaryLoading: boolean;
  confirming: boolean;
  phase: string;
  sessionId: string | null;
  onGenerateSummary: () => void;
  onSuccessScreenAction: (isFinal: boolean) => void;
  onSummaryGenerated: (summaryData: any, newPhase: string) => void;
  onReturningForInterview: () => void;
  setPhase: (phase: string) => void;
  setConfirming: (confirming: boolean) => void;
}

const InterviewCompletionScreen: React.FC<InterviewCompletionScreenProps> = ({
  allPhasesComplete,
  summary,
  summaryLoading,
  confirming,
  phase,
  sessionId,
  onGenerateSummary,
  onSuccessScreenAction,
  onSummaryGenerated,
  onReturningForInterview,
  setPhase,
  setConfirming
}) => {
  return (
    <div className="text-center py-16">
      <div className="w-24 h-24 bg-gradient-to-r from-purple-100 to-pink-100 rounded-full flex items-center justify-center mx-auto mb-8">
        <CheckCircle className="w-12 h-12 text-purple-500" />
      </div>
      <h2 className="text-3xl font-bold text-gray-900 mb-6">
        {allPhasesComplete ? "All Phases Complete!" : "All Questions Completed!"}
      </h2>
      <p className="text-gray-600 mb-10 text-lg leading-relaxed">
        You have successfully answered all interview questions. Click
        below to generate your summary.
      </p>
      <div className="flex gap-4 justify-center">
        {/* Only show Generate Summary button if no summary exists */}
        {!summary && (
          <button
            onClick={onGenerateSummary}
            style={{ background: "linear-gradient(135deg, #bb1ccc 0%, #d946ef 100%)" }}
            className="inline-flex items-center gap-3 px-10 py-4 text-white rounded-xl font-semibold hover:opacity-90 transition-all duration-200 text-lg shadow-lg transform hover:scale-105"
            disabled={summaryLoading}
          >
            <FileText className="w-6 h-6" />
            {summaryLoading ? "Generating..." : "Generate Summary"}
          </button>
        )}
        
        {/* Show Review Phase Summary button when summary exists */}
        {summary && (
          <CustomizedDialogs
            text={summary}
            sessionId={sessionId}
            ingest_type={phase}
            setPhase={setPhase}
            setConfirming={setConfirming}
            onSuccess={onSuccessScreenAction}
            onSummaryGenerated={onSummaryGenerated}
          />
        )}
        
        {/* Show Interview For Next Phase button when confirming and not final phase */}
        {confirming && phase !== 'final' && (                
          <button
            onClick={onReturningForInterview}
            className="inline-flex items-center gap-3 px-10 py-4 rounded-xl font-semibold hover:opacity-90 transition-all duration-200 text-lg border-2 transform hover:scale-105"
            style={{
              borderColor: "#bb1ccc",
              color: "#bb1ccc",
              backgroundColor: "transparent",
            }}
            disabled={summaryLoading}
          >
            <FileText className="w-6 h-6" />
            {"Interview For Next Phase"}
          </button>
        )}
      </div>
    </div>
  );
};

export default InterviewCompletionScreen;